import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-records', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/disciplinary-records', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/disciplinary-records/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/disciplinary-records/${data.dis_record_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/disciplinary-records/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const subject = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-records/subjects', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const subType = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-records/subTypes', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const activity = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-records/activities', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const previewPdf = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-records/pdf-previews', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = (data = {}) => {
  return httpClient
    .post('/api/disciplinary-records/export-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}



export default {
  get,
  find,
  store,
  update,
  destroy,
  subject,
  subType,
  activity,
  previewPdf,
 exportExcel
}
